// extracted by mini-css-extract-plugin
export default {"dividingLine":"dividingLine-jcM5S","informationWrapper":"informationWrapper-DwWpm","listingInformation":"listingInformation-ztDOH"};